import { render, staticRenderFns } from "./rate-sys.vue?vue&type=template&id=2d560fd6"
import script from "./rate-sys.vue?vue&type=script&lang=ts"
export * from "./rate-sys.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports